import { keyframes } from 'styled-components';

export const waveSquaresKeyframes = keyframes`
    0% {
        background-position: -468px 0;
    }
    100% {
        background-position: 468px 0;
    }
`;
